/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassStatus {
  PENDING_PAYMENT = 'pending_payment',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  ARCHIVED = 'archived',
  EXPIRED = 'expired',
}
